import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const seoApi = createApi({
  reducerPath: "seoApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "seo-page/",
    prepareHeaders: (headers, { getState }) => {
      const token = getState().authSlice?.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),

  endpoints: (builder) => ({
    getPagesSeoApi: builder.query({
      query: ({ route }) => ({
        url: route,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetPagesSeoApiQuery } = seoApi;
